import React from 'react'

import Drawer from './Drawer'
import DrawerHeader from './DrawerHeader'

interface DrawerWithPanelProps {
  children: React.ReactNode
  onClose: () => void
  open: boolean
  title: string
  subtitle?: string
  imageUrl: string
  customHeader?: React.ReactElement
  anchor?: string
  description?: string
  dataTestId?: string
}

const DrawerWithPanel: React.FC<DrawerWithPanelProps> = ({
  onClose,
  open,
  ...rest
}) => {
  return (
    <Drawer open={open} onClose={onClose} {...rest}>
      {rest.customHeader ? (
        React.cloneElement(rest.customHeader, { onClose } as Record<
          string,
          unknown
        >)
      ) : (
        <DrawerHeader
          title={rest.title}
          subtitle={rest.subtitle}
          onClose={onClose}
          imageUrl={rest.imageUrl}
          description={rest.description}
        />
      )}
      {rest.children}
    </Drawer>
  )
}

export default DrawerWithPanel
